(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_matching-pots"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aurea-matching-pots')) {
    customElements.define(
      'aurea-matching-pots',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.scrollHandlerReady === 'true') return;
          this.dataset.scrollHandlerReady = 'true';

          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-scroll-direction]');
            if (!button || !this.contains(button)) return;

            const track = this.querySelector('.aurea-matching-pots__track');
            const firstCard = track?.querySelector('.aurea-matching-pots__card');
            if (!track || !firstCard) return;

            const step = firstCard.getBoundingClientRect().width + 12;
            track.scrollBy({
              left: step * 2 * Number(button.dataset.scrollDirection),
              behavior: 'smooth',
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
